export default __webpack_public_path__ + "static/media/m.1e882569.jpg";